<ion-content>
  <ion-button *ngIf="!isEngaged" (click)="onScanQrCode()" expand="block" translate largeFont>
    <ion-icon slot="start" name="qr-code"></ion-icon>
    Mobile.ScanQrCode
  </ion-button>

  <qrcode [qrdata]="qrData" [width]="256"></qrcode>
</ion-content>
